import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import ReactPlayer from 'react-player'
import classnames from 'classnames'
import Helmet from 'react-helmet'
import ReactGA from 'react-ga'

import Header from './Components/Header'
import Footer from './Components/Footer'
import { routes, lesserRoutes } from './content/routes'
import * as helpers from './helpers'

const routeWrapper = (r, globalProps) => {
  const View = r.viewComponent
  const path = r.path
  const content = r.content
  const WrappedRoute = (
    <Route
      path={path}
      key={path}
      render={props => {
        const extraRouteProps = r.props || {}
        const routeProps = Object.assign(
          {},
          { ...props },
          { ...globalProps },
          { ...extraRouteProps }
        )
        return (
          <RouteWrapper
            key={path}
            content={content}
            View={View}
            {...routeProps}
          />
        )
      }}
    />
  )
  const WrappedRouteHome = (
    <Route
      exact
      path={'/'}
      key={path}
      render={props => {
        const routeProps = Object.assign({}, { ...props }, { ...globalProps })
        return (
          <RouteWrapper
            key={path}
            content={content}
            View={View}
            {...routeProps}
          />
        )
      }}
    />
  )

  let ret = r.path === '/' ? WrappedRouteHome : WrappedRoute

  // console.log(ret);

  return ret
}

class Main extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentRoute: routes[0],
      headerColor: 'LIGHT',
      mobileTrayOpen: false,
      isModalOpen: false,
      isTokenModalOpen: false
    }
  }

  setCurrentRoute = path => {
    let currentRoute = routes.find(r => r.path === path)
    // if no match, currentRoute = 404 page, which is the last route in the routes array
    currentRoute = !currentRoute ? routes[routes.length - 1] : currentRoute
    this.setState({ currentRoute })
  }

  closeMobileTray = () => {
    this.setState({ mobileTrayOpen: false })
  }

  componentWillMount = () => {
    const GAKey =
      process.env.node_env === 'development'
        ? 'deadbeef'
        : process.env.REACT_APP_GA_ANALYTICS_KEY
    ReactGA.initialize(GAKey)
    window.addEventListener('keydown', e => this.handleKeyDown(e))
  }

  wrapRoutes = (routes, globalProps) => {
    return routes.reduce((acc, r) => {
      var res = []
      if (r.path != null) {
        res = res.concat([routeWrapper(r, globalProps)])
      }
      if (r.children != null) {
        res = res.concat(r.children.map(r_ => routeWrapper(r_, globalProps)))
      }
      return acc.concat(res)
    }, [])
  }

  updateHeaderStyle = (y, sections) => {
    const hh = helpers.hh + 12 // header height
    const currentSection = sections.filter(section => {
      return (
        section.fromTop <= y + hh && section.fromTop + section.height > y + hh
      )
    })
    if (currentSection[0]) {
      const headerColor = currentSection[0].color
      if (this.state.headerColor !== headerColor) {
        this.setState({ headerColor })
      }
    }
  }

  toggleMobileTray = () => {
    this.setState({ mobileTrayOpen: !this.state.mobileTrayOpen })
  }

  handleToggleModal = () => {
    this.state.isModalOpen ? this.closeModal() : this.openModal()
  }

  handleToggleTokenModal = () => {
    this.state.isTokenModalOpen ? this.closeTokenModal() : this.openTokenModal()
  }

  openModal = () => {
    this.setState({ isModalOpen: true })
  }

  closeModal = () => {
    this.setState({ isModalOpen: false })
  }

  openTokenModal = () => {
    this.setState({ isTokenModalOpen: true })
  }

  closeTokenModal = () => {
    this.setState({ isTokenModalOpen: false })
  }

  handleKeyDown = e => {
    if (e.keyCode === 27) {
      this.closeModal()
      this.closeTokenModal()
    }
  }

  render() {
    const { currentRoute, isModalOpen, isTokenModalOpen } = this.state
    const globalProps = {
      closeMobileTray: this.closeMobileTray,
      setCurrentRoute: this.setCurrentRoute,
      currentRoute,
      updateHeaderStyle: this.updateHeaderStyle,
      handleToggleModal: this.handleToggleModal,
      openModal: this.openModal,
      closeModal: this.closeModal,
      isModalOpen,
      openTokenModal: this.openTokenModal,
      closeTokenModal: this.closeTokenModal,
      isTokenModalOpen,
      web3: this.props.web3
    }

    const pageTitle =
      currentRoute.name === 'Home'
        ? 'FOAM • The Future of Proof of Location'
        : `FOAM • ${currentRoute.title || currentRoute.name}`

    return (
      <Router>
        <div id={'main-root'}>
          <Header
            headerColor={this.state.headerColor}
            routes={routes}
            lesserRoutes={lesserRoutes}
            currentRoute={currentRoute}
            mobileTrayOpen={this.state.mobileTrayOpen}
            toggleMobileTray={() => this.toggleMobileTray()}
          />

          <Helmet>
            <title>{pageTitle}</title>
            <meta name={'description'} content={currentRoute.description} />
          </Helmet>

          <Switch>{this.wrapRoutes(routes, globalProps)}</Switch>

          <Footer
            lesserRoutes={lesserRoutes}
            routes={routes}
            currentRoute={currentRoute}
          />

          <Modal
            heroVideo={'https://youtu.be/EJeMVh4tm1w'}
            isShowing={isModalOpen}
            closeModal={this.closeModal}
          />
          <Modal
            heroVideo={'https://youtu.be/LKb0y8z9TJg'}
            isShowing={isTokenModalOpen}
            closeModal={this.closeTokenModal}
          />
        </div>
      </Router>
    )
  }
}

class RouteWrapper extends Component {
  componentWillMount() {
    ReactGA.pageview(window.location.pathname + window.location.search)
    this.props.setCurrentRoute(this.props.location.pathname)
    this.props.closeMobileTray()
  }
  render() {
    const { View } = this.props
    return <View {...this.props} />
  }
}

function Modal({ heroVideo, isShowing, closeModal }) {
  const isShowingClasses = classnames({
    hideModal: !isShowing,
    showModal: isShowing,
    videoModal: true
  })
  const config = {
    youtube: {
      playerVars: { playsinline: 0 }
    }
  }
  return (
    <div className={isShowingClasses}>
      <button onClick={() => closeModal()}>{'×'}</button>
      <ReactPlayer
        playing={isShowing}
        controls={false}
        url={heroVideo}
        style={{
          width: '100vw',
          height: '100vh'
        }}
        config={config}
      />
    </div>
  )
}

export default Main



// WEBPACK FOOTER //
// ./src/Main.js